import { useMutation } from 'react-query'
import { CreateMediaResponse, MediaApi, ValidationFailed } from '@trybeapp/sdk'
import { apiConfiguration } from 'utilities/TrybeApiClient'

const api = new MediaApi(apiConfiguration)

export const useUploadMedia = () =>
  useMutation<CreateMediaResponse, ValidationFailed, File>((image) => api.createMedia({ image }))

export const useUploadFile = () =>
  useMutation<CreateMediaResponse, ValidationFailed, File>((file) => api.createMedia({ file }))
